import { cn } from "@/lib/cn";

interface PrismLogoProps {
  size?: number;
  className?: string;
  withWordmark?: boolean;
}

/**
 * PrismLogo — Electric Aurora prizma (inline SVG, shaffof fon).
 * WHY: oldingi `logo.webp` raster qora fonli edi — turli fonlarda qora kvadrat
 * bo'lib ko'rinardi va violet yo'q edi. Inline SVG har o'lchamda tiniq, temaga
 * mos (violet→blue→cyan) va shaffof.
 */
export function PrismLogo({ size = 40, className, withWordmark = false }: PrismLogoProps) {
  return (
    <div className={cn("flex shrink-0 items-center gap-3", className)}>
      <span
        className="relative inline-flex shrink-0 items-center justify-center"
        style={{ width: size, height: size }}
      >
        <svg
          width={size}
          height={size}
          viewBox="0 0 32 32"
          fill="none"
          role="img"
          aria-label="Prism OS"
          style={{ filter: "drop-shadow(0 0 6px rgba(79,143,255,0.45))" }}
        >
          <defs>
            <linearGradient id="prism-logo-aurora" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#8B5CF6" />
              <stop offset="50%" stopColor="#4F8FFF" />
              <stop offset="100%" stopColor="#22D3EE" />
            </linearGradient>
          </defs>
          {/* Prizma uchburchak */}
          <path
            d="M16 4 L28 26 L4 26 Z"
            fill="url(#prism-logo-aurora)"
            stroke="url(#prism-logo-aurora)"
            strokeWidth="0.5"
            strokeLinejoin="round"
          />
          {/* Ichki nur chizig'i */}
          <path
            d="M16 8 L24 24 L8 24 Z"
            fill="none"
            stroke="#F4F4F8"
            strokeOpacity="0.18"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      {withWordmark && (
        <span className="font-display text-lg font-semibold tracking-tight text-[var(--text-primary)]">
          Prism OS
        </span>
      )}
    </div>
  );
}
